'use client';

import React, { useState } from 'react';
import { useNotificationPages } from '../hooks/useNotificationPages';
import { LinkWrapper } from '../utils/link';

export const Notifications = () => {
  const [visible, setVisible] = useState(1);

  const notifications = useNotificationPages();

  const hide = () => {
    setVisible(false);
  };

  return notifications.map((notification) => {
    const publish = Date.parse(notification.publish_end) > Date.now();

    if (publish) {
      if (notification.type === 'feedback') {
        return (
          <div
            className="fixed bg-black-12.5 rounded-t font-crystalCondensed text-sm px-4 py-2 drop-shadow z-40"
            style={{
              bottom: '50%',
              right: '0px',
              transformOrigin: '100% 100%',
              height: '2.375rem',
              transform: 'rotateZ(-90deg) translateX(50%) translateY(0px)',
            }}
            key={notification._uid}
          >
            {notification.link.linktype === 'story' && (
              <LinkWrapper
                link={notification.link}
                className="no-underline opacity-70 hover:opacity-100"
              >
                {notification.message}
              </LinkWrapper>
            )}
          </div>
        );
      } else
        return (
          <div
            className={`sticky bottom-0 w-full p-4 bg-black text-white ${
              visible === false ? 'hidden' : ''
            }`}
            key={notification._uid}
          >
            <div className="w-full max-w-7xl mx-auto sm:px-6 flex justify-between">
              <div>
                <LinkWrapper link={notification.link}>
                  {notification.message}
                </LinkWrapper>
              </div>
              <div>
                <button className="p-0 m-0" onClick={hide}>
                  X
                </button>
              </div>
            </div>
          </div>
        );
    } else {
      return null;
    }
  });
};
